import type { ReactNode } from "react";

export type BillingPlan = "monthly" | "annual";

export function PricingCards({ onSelect, currentPlan = "free", busy = false }: {
  onSelect?: (plan: BillingPlan) => void;
  currentPlan?: string;
  busy?: boolean;
}) {
  const action = (plan: BillingPlan, label: string) => onSelect
    ? <button className="price-action" onClick={() => onSelect(plan)} disabled={busy || currentPlan === plan}>{currentPlan === plan ? "Current plan" : label}</button>
    : <a className="price-action" href={`/?plan=${plan}`}>{label}</a>;
  return <div className="pricing-grid">
    <article><p className="price-name">FREE</p><h2>$0</h2><span>Try the complete loop</span><ul><li>One meal check each day</li><li>One nutrition-plan import</li><li>Daily protein and fiber progress</li><li>One practical food fix</li></ul><a className="price-action secondary" href="/">Start free</a></article>
    <article><p className="price-name">MONTHLY</p><h2>$4.99<small>/month</small></h2><span>Flexible, cancel anytime</span><ul><li>Unlimited meal checks</li><li>Unlimited plan updates</li><li>Daily protein and fiber progress</li><li>Secure recurring billing through PayPal</li></ul>{action("monthly", "Choose monthly")}</article>
    <article className="featured"><div className="popular">BEST VALUE</div><p className="price-name">ANNUAL</p><h2>$39.99<small>/year</small></h2><span>About $3.33 per month</span><ul><li>Everything in Monthly</li><li>Save about 33%</li><li>Founding-product pricing</li><li>Cancel future renewals in the app</li></ul>{action("annual", "Choose annual")}</article>
  </div>;
}

export function PublicPricingPage({ navigation, authenticated = false, onSelect, currentPlan = "free", busy = false, message = "" }: {
  navigation: ReactNode;
  authenticated?: boolean;
  onSelect?: (plan: BillingPlan) => void;
  currentPlan?: string;
  busy?: boolean;
  message?: string;
}) {
  return <main className="public-pricing">{navigation}<header><p className="eyebrow">SIMPLE PRICING</p><h1>Track less.<br />Follow through more.</h1><p>Experience the full meal-check loop before paying. Upgrade only when the habit is useful.</p>{authenticated && <p className="pricing-session-note">You are signed in. Choosing a paid plan continues directly to secure PayPal approval.</p>}{message && <p className="pricing-message">{message}</p>}</header><PricingCards onSelect={authenticated ? onSelect : undefined} currentPlan={currentPlan} busy={busy} /><footer><span>Prices in USD. Recurring checkout and payment processing are provided by PayPal.</span><div><a href="/privacy">Privacy</a><a href="/terms">Terms</a></div></footer></main>;
}

export function PricingModal({ onSelect, onClose, currentPlan, busy, onManage }: {
  onSelect: (plan: BillingPlan) => void;
  onClose: () => void;
  currentPlan: string;
  busy: boolean;
  onManage?: () => void;
}) {
  return <div className="pricing-overlay"><section><button className="pricing-close" onClick={onClose}>×</button><p className="eyebrow">CHOOSE YOUR GUARD</p><h1>Keep the useful part unlimited.</h1><PricingCards onSelect={onSelect} currentPlan={currentPlan} busy={busy} />{onManage && <button className="manage-billing" onClick={onManage}>Cancel PayPal renewal</button>}</section></div>;
}
